<template>
  <div>
    <header-bar>
      届出内容確認
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">届出内容確認</h3>
        <span
          v-if="isDeliveredTrack"
          class="delivered-song-label">
          配信済み
        </span>
      </div>
      <div class="page-block__inner">
        <div class="form-wrap">
          <div
            class="form-group-wrap__title copyright-main-title"
            style="margin-top: 10px">
            <label
              class="control-label"
              for="title">
              作品タイトル
            </label>
          </div>
          <div
            class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="copyright_application_id">
                著作権申請ID
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.product_disc_track_id }}-{{ item.id }}
            </div>
          </div>
          <div
            v-if="item.work_code"
            class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_ja">
                作品コード
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.work_code }}
            </div>
          </div>
          <!-- TITLE START -->
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_ja">
                タイトル名
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.title_ja }}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_kana">
                タイトル名（カナ表記）
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.title_kana }}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_ja">
                タイトル名（アルファベット表記）
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.title_en }}
            </div>
          </div>
          <!-- TITLE END -->
          <!--MAIN ARTIST START-->
          <template>
            <div class="form-group-wrap pb-0">
              <div class="form-group-wrap__title">
                メインアーティスト
                <span class="req">＊</span>
              </div>
              <div
                v-for="(mArtist, index) in item.artists.main_artists"
                :key="index">
                <copyright-artist-confirm :artist="mArtist" />
              </div>
            </div>
          </template>
          <!--MAIN ARTIST END-->
          <!--FEATURING ARTIST START-->
          <template>
            <div class="form-group-wrap pb-0">
              <div class="form-group-wrap__title">
                Featuringアーティスト
                <span
                  v-if="isEmptyFeaturingArtists"
                  class="no-featuring-artist-text">
                  未設定
                </span>
              </div>
              <template v-if="hasFeaturingArtists">
                <div
                  v-for="(fArtist, index) in item.artists.featuring_artists"
                  :key="index">
                  <copyright-artist-confirm :artist="fArtist" />
                </div>
              </template>
            </div>
          </template>
          <!--FEATURING ARTIST END-->
          <!-- INSTRUMENTAL START -->
          <div class="form-group">
            <div class="form-label">
              <label class="control-label">インストゥルメンタル
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.is_instrumental ? '有' : '無' }}
            </div>
          </div>
          <!-- INSTRUMENTAL END -->
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="play_time_min">演奏時間
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item-inline">
              <div class="form-item">
                {{ `${item.play_time_min}分 ${item.play_time_sec}秒` }}
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label class="control-label">
                発売日
                <span class="req">＊</span>
              </label>
            </div>
            <div
              class="form-item word-break">
              {{ item.released_date }}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="label_name">
                レーベル名
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.label_name }}
            </div>
          </div>
          <!--AUTHOR START-->
          <div class="form-group-wrap border-none">
            <div class="form-group-wrap__title">
              <label class="control-label">
                著作者
                <span class="req">＊</span>
              </label>
            </div>
            <div
              v-for="(author, index) in item.authors"
              :key="index">
              <div>
                <div class="form-wrap author-form-wrap--with-border">
                  <div class="form-group">
                    <div class="form-label">
                      <label class="control-label">この著作者はアカウント管理者本人ですか？</label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ author.author_meta.is_owner ? 'はい' : 'いいえ' }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label class="control-label">著作者区分</label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ mapRoles(author.pivot.author_roles) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label class="control-label">グループ</label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ author.author_meta.is_group ? '有' : '無' }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        :for="'artist_name_domestic' + index">著作者公表名
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ author.name_ja }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        :for="'artist_name_kana' + index">著作者公表名（カナ表記）
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.name_kana }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label form-label--top">
                      <label
                        class="control-label"
                        :for="'artist_name_overseas' + index">著作者公表名（アルファベット表記）
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.name_en }}
                    </div>
                  </div>
                  <div
                    v-if="!author.author_meta.is_owner"
                    class="form-group">
                    <div class="form-label form-label--top">
                      <label
                        class="control-label"
                        :for="'author_email' + index">著作者メールアドレス
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.author_meta.email }}
                    </div>
                  </div>
                  <div v-if="author.author_meta.group_meta.length === 0">
                    <div class="form-group">
                      <div class="form-label form-label--top">
                        <label
                          class="control-label"
                          :for="'artist_name_ja_name' + index">著作者実名
                          <span class="req">＊</span>
                        </label>
                      </div>
                      <div class="form-item word-break">
                        {{ author.author_meta.personal_meta.real_name.ja.name }}
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="form-label form-label--top">
                        <label
                          class="control-label"
                          :for="'artist_name_en_name' + index">著作者実名（アルファベット表記）
                          <span class="req">＊</span>
                        </label>
                      </div>
                      <div class="form-item word-break">
                        {{ author.author_meta.personal_meta.real_name.en.name }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="author.author_meta.is_group"
                    class="members b-1">
                    <div
                      v-for="(gItem, mIndex) in author.author_meta.group_meta"
                      :key="mIndex">
                      <div class="form-group">
                        <div class="form-label form-label--top">
                          <label
                            class="control-label"
                            :for="'member_ja_name'+ mIndex">メンバー{{ mIndex + 1 }}実名
                            <span class="req">＊</span>
                          </label>
                        </div>
                        <div class="form-item word-break">
                          {{ gItem.real_name.ja.name }}
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-label form-label--top">
                          <label
                            class="control-label"
                            :for="'member_en_name'+ mIndex">メンバー{{ mIndex + 1 }}実名
                            <span class="req">＊</span>
                          </label>
                        </div>
                        <div class="form-item word-break">
                          {{ gItem.real_name.en.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="author.author_meta.group_meta.length === 0"
                    class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label">
                        JASRACメンバーですか？<br>
                        (海外著作権団体のメンバーですか？)
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.author_meta.personal_meta.is_jasrac_member ? 'はい' : 'いいえ' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--AUTHOR END-->
        </div>
        <div v-if="!readOnly">
          <div
            class="release-caution-area u-no-margin-top">
            <div class="release-caution-area__title">【ご注意】</div>
            <div class="release-caution-area__paragraph">
              <ul class="c-indent-list">
                <li
                  class="c-indent-list__node">
                  私は、本サービスに関する<a
                    class="c-text-link"
                    target="_blank"
                    href="https://narasu.jp/client/static/copyright-terms">規約</a>に同意のうえ、届出申請をします。
                </li>
                <li
                  class="c-indent-list__node">
                  私は、<a
                    class="c-text-link"
                    target="_blank"
                    href="https://narasu.jp/client/static/copyright-assignment-terms">音楽著作権の期間及び限定譲渡に関する規約</a>に同意のうえ、届出申請をします。
                </li>
                <li
                  class="c-indent-list__node">
                  私は、本作品に関し、届出申請をする上で正当な権利を保持しています。
                </li>
                <li
                  class="c-indent-list__node">
                  私は、未成年ではありません。または保護者の同意を得ました。
                </li>
                <li
                  class="c-indent-list__node">
                  届出申請後は著作者情報を変更することができません。
                </li>
                <li
                  class="c-indent-list__node">
                  著作権譲渡期間は5年間となり、更新タイミング以外での管理停止は原則承っておりません。
                </li>
                <li
                  class="c-indent-list__node">
                  生成AIを用いて制作された作品の場合、本サービスをご利用いただくことはできません。
                </li>
                <li
                  class="c-indent-list__node">
                  登録完了までに数ヶ月かかる場合があります。
                </li>
                <li
                  class="c-indent-list__node">
                  申請作品の管理登録をお約束するものではなく、ご要望に添えない場合もあります。
                </li>
              </ul>
            </div>
          </div>
          <div
            class="confirm-checkbox-area">
            <div class="checkbox">
              <label>
                <input
                  v-model="confirmed"
                  type="checkbox">
                <div class="option-input"></div>
                注意事項を確認しました
              </label>
            </div>
          </div>
          <div
            class="release-caution-area u-no-margin-top checkbox-list">
            <div class="release-caution-area__title">
              【著作権管理サービスについて】
            </div>
            私は、著作権登録サービスを利用する楽曲は、以下の全ての項目に該当しないことを確認しました。<br />
            <p class="border-checkbox-item">
              チェックボックス内にチェックをお入れください。
            </p>
            <div
              v-for="(label, checkboxIndex) in copyrightRegistrationServiceItemLabel"
              :key="checkboxIndex"
              class="checkbox m-right-0">
              <label
                class="checkbox-list-label">
                <input
                  v-model="copyrightRegistrationServiceItemsValue[checkboxIndex]"
                  type="checkbox">
                <div class="option-input"></div>
                <div>
                  {{ label }}
                </div>
              </label>
            </div>
            <span>「ご自身の作品が登録済みか確認する方法」は<a
              class="c-text-link mt-30"
              target="_blank"
              href="https://www2.jasrac.or.jp/eJwid/">こちら</a>（JWID）</span>
          </div>
        </div>
        <div
          class="c-btn-wrap">
          <button
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="onReturnClicked">
            {{ isProgressStatus ? '一覧へ戻る' : '戻る' }}
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </button>
          <button
            v-if="!readOnly"
            :class="{ 'c-btn--off' : !confirmed
              || !allCopyrightRegistrationServiceItemChecked
              || !isEnabledCopyrightOperation()}"
            :disabled="!confirmed
              || !allCopyrightRegistrationServiceItemChecked
              || !isEnabledCopyrightOperation()"
            class="c-btn"
            @click.prevent="onSaveClicked">
            申請する
            <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderBar from '../HeaderBar'
import CopyrightArtistConfirm from './Common/ArtistConfirm'
import {
  CMAP_COPYRIGHT_STATUS_IN_PENDING,
  CMAP_COPYRIGHT_STATUS_IN_PROGRESS,
  CMAP_COPYRIGHT_STATUS_IN_REVIEW,
  CMAP_COPYRIGHT_STATUS_PROCESSING,
  CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS,
} from '../../../consts/status'

export default {
  name: 'Confirm',
  components: {
    HeaderBar,
    CopyrightArtistConfirm,
  },
  data() {
    return {
      item: {
        title_ja: '',
        title_kana: '',
        title_en: '',
        versions: [],
        artists: {
          main_artists: [],
          featuring_artists: [],
        },
        authors: [],
        is_instrumental: false,
        play_time_min: 0,
        play_time_sec: 0,
        released_date: '',
        label_name: '',
        product_disc_track_id: '',
        status: CMAP_COPYRIGHT_STATUS_IN_PROGRESS,
      },
      hasGuest: false,
      readOnly: false,
      confirmed: false,
      copyrightRegistrationServiceItemLabel: [
        'AIによって自律的に自動生成し、作詞または作曲された作品',
        '著作権管理団体へ登録済の楽曲／narasu以外からの著作権登録中または登録済み',
        '登録済みの楽曲のアレンジ違い・バージョン違い',
        '第三者が権利を有する曲をサンプリング使用した楽曲',
        '環境音やノイズのみの楽曲',
        'オリジナルでない楽曲（バージョン項目に表記がある楽曲）',
      ],
      copyrightRegistrationServiceItemsValue: [false, false, false, false, false, false],
    }
  },
  computed: {
    isEmptyVersion() {
      return (this.item.versions && this.item.versions.length === 0)
    },
    isEmptyFeaturingArtists() {
      return this.item.artists.featuring_artists && this.item.artists.featuring_artists.length === 0
    },
    hasFeaturingArtists() {
      return this.item.artists.featuring_artists && this.item.artists.featuring_artists.length > 0
    },
    hasVersions() {
      return this.item.versions && this.item.versions.length > 0
    },
    isDeliveredTrack() {
      return this.item.type === 0
    },
    isProgressStatus() {
      return this.item.status === CMAP_COPYRIGHT_STATUS_IN_PROGRESS
    },
    allCopyrightRegistrationServiceItemChecked() {
      return this.copyrightRegistrationServiceItemsValue.every(item => item === true)
    },
  },
  async mounted() {
    await this.getCopyrights(this.$route.params.id)
    if (
      this.item.status === CMAP_COPYRIGHT_STATUS_IN_REVIEW
      || this.item.status === CMAP_COPYRIGHT_STATUS_PROCESSING
      || this.item.status === CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS
    ) {
      this.readOnly = true
    }
    const hasGuest = this.item.authors.some(author => author.author_meta.is_owner === false)
    window.sessionStorage.setItem('hasGuest', hasGuest.toString())
  },
  methods: {
    async getCopyrights(id) {
      const { data } = await window.axios.get('/api/client/copyrights', {
        params: {
          id,
        },
      })
      const copyrights = data.data[0]
      const [playTimeMin, playTimeSec] = copyrights.play_time.split(':')
      copyrights.play_time_min = playTimeMin
      copyrights.play_time_sec = playTimeSec
      copyrights.is_instrumental = copyrights.is_instrumental === 1
      this.item = { ...this.item, ...copyrights }
    },
    async onSaveClicked() {
      const { id } = this.item
      this.item.status = CMAP_COPYRIGHT_STATUS_IN_PENDING
      await window.axios.put(`/api/client/copyrights/${id}/change-status`, this.item)
      window.sessionStorage.setItem('copyrightTitle', this.item.title_ja)
      await this.$router.push({ name: 'copyright-completed' })
    },
    onReturnClicked() {
      this.$router.push({ name: 'copyright-index' })
    },
    mapRoles(inputArray) {
      const checkedRoles = inputArray
        .filter(role => role.checked)
        .map(role => role.label)

      return checkedRoles.join(', ')
    },
    isEnabledCopyrightOperation() {
      return this.$store.state.auth.enable_copyright_operation
    },
  },
}
</script>
<style scoped>
.border-none {
  border: 0
}
.pb-0 {
  padding-bottom: 0 !important;
}
.word-break {
  word-break: break-all;
}
.delivered-song-label {
  position: absolute;
  right: 20px;
  height: 35px;
  width: 120px;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: white;
  padding: 7px 0 2px 0;
  margin: 0;
  background-color: #4bc1f2;
}
.form-group-wrap {
  border-bottom: none;
}
.author-form-wrap--with-border {
  padding: 30px;
  border: 2px solid #dadada;
  margin: 30px 0 0 0 !important;
}

.b-1 {
  border: 1px solid #dadada !important;
  border-radius: 5px;
  padding: 0 10px 10px 20px;
  margin-top: 30px;
}
.word-break {
  word-break: break-all;
}

.border-checkbox-item {
  border-bottom: 2px dotted black;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.checkbox-list {
  display: flex;
  flex-direction: column;
}
.checkbox-list-label {
  font-weight: normal;
  max-width: 550px;
}
.m-right-0{
  margin-right: 0;
}
.mt-30 {
  margin-top: 30px;
}

@media screen and (max-width: 895px) {
  .form-group-wrap__title span {
    display: unset;
  }
  .checkbox-list-label {
    line-height: 38px !important;
  }
}
</style>
